<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="45%"
    :before-close="handleClose"
  >
    <el-row>
      <el-form
        ref="form"
        :model="CustomerReplay"
        :rules="rules"
        label-width="140px"
      >
        <el-form-item label="访问时间:" prop="Time">
          <el-date-picker
            v-model="CustomerReplay.Time"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            align="right"
            start-placeholder="开始日期"
            range-separator="至"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="出访地址:" prop="Area" style="width: 400px">
          <div class="block">
            <el-cascader
              v-model="CustomerReplay.Area"
              :options="arealist"
              :props="{ expandTrigger: 'hover' }"
              style="width: 400px"
            ></el-cascader>
          </div>
        </el-form-item>
        <el-form-item prop="Address">
          <el-input
            v-model="CustomerReplay.Address"
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="出访目的:" prop="Purpose">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入出访目的"
            v-model="CustomerReplay.Purpose"
          ></el-input>
        </el-form-item>
        <el-form-item label="问题卡点:" prop="Question">
          <el-input
            v-model="CustomerReplay.Question"
            placeholder="请输入问题卡点"
          ></el-input>
        </el-form-item>
        <el-form-item label="下步规划:" prop="Planning">
          <el-input
            v-model="CustomerReplay.Planning"
            placeholder="请输入下步规划"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户沟通记录截图:" prop="RecordPic">
          <div class="upbox">
            <el-upload
              class="upload-demo"
              action="http://eapi.ruizhiqi.cn/api/upload/uploadformdata"
              list-type="picture-card"
              size="small"
              :file-list="CustomerReplay.fileList2"
              :multiple="multiple"
              :before-upload="checkFile"
              :on-success="upload2"
              :on-error="uploaderror"
            >
              <i class="el-icon-upload2"></i>
            </el-upload>
            <p class="cr">包含同客户沟通出访事宜事项</p>
            <div class="clear"></div>
          </div>
        </el-form-item>
        <el-form-item label="出访水印打卡照片:" prop="PunchPic">
          <div class="upbox">
            <el-upload
              class="upload-demo"
              action="http://eapi.ruizhiqi.cn/api/upload/uploadformdata"
              list-type="picture-card"
              size="small"
              :file-list="CustomerReplay.fileList1"
              :multiple="multiple"
              :before-upload="checkFile"
              :on-success="upload1"
              :on-error="uploaderror"
            >
              <i class="el-icon-upload2"></i>
            </el-upload>
            <p class="cr">要求有时间地点，并于本人同框</p>
            <div class="clear"></div>
          </div>
        </el-form-item>
        <el-form-item label="客户数据复盘表:" prop="ReviewReport">
          <div class="upbox" v-if="CustomerReplay.ReviewReport == ''">
            <el-upload
              class="upload-demo2"
              action="http://eapi.ruizhiqi.cn/api/upload/uploadformdata"
              :multiple="multiple"
              :before-upload="checkFile"
              :on-success="upload3"
              :on-error="uploaderror"
            >
              <el-button size="small" type="primary" class="upbtn"
                >选择文件</el-button
              >
            </el-upload>
          </div>
          <div class="pic" v-if="CustomerReplay.ReviewReport != ''">
            <i class="el-icon-folder-opened"></i>
            <el-button type="text" @click="delupload3">删除</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="EventCancel">取 消</el-button>
      <el-button type="primary" @click="EventSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {} from "@/until/ZeusApiSDK/Logic/CustomerProfile";
import areaData from "./areaData.json";
export default {
  name: "addReplay",
  data() {
    return {
      arealist: areaData,
      multiple: false,
      rules: {
        Area: [{ required: true, message: "请选择地址", trigger: "blur" }],
        Address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        Purpose: [
          { required: true, message: "请输入出访目的", trigger: "blur" },
        ],
        Time: [{ required: true, message: "请选择出访时间", trigger: "blur" }],
        Question: [
          { required: true, message: "请输入问题卡点", trigger: "blur" },
        ],
        Planning: [
          { required: true, message: "请输入下步规划", trigger: "blur" },
        ],
        PunchPic: [
          {
            required: false,
            message: "请上传出访水印打卡照片",
            trigger: "blur",
          },
        ],
        RecordPic: [
          {
            required: true,
            message: "请上传客户沟通记录截图",
            trigger: "blur",
          },
        ],
        ReviewReport: [
          { required: true, message: "请上传客户数据复盘表", trigger: "blur" },
        ],
      },
    };
  },
  props: {
    CustomerReplay: {
      type: Object,
    },
    visible: {
      type: Boolean,
    },
    dialogTitle: {
      type: String,
    },
  },
  methods: {
    handleClose() {
      // this.visible = false;
      this.$emit("close");
    },
    EventCancel() {
      this.$emit("close");
    },
    EventSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit("submit");
        } else {
          this.$message.error("请检查表单填写完毕后再试~");
          return false;
        }
      });
    },
    checkFile(e) {
      //console.log(e, "------上传文件之前的钩子");
      if (e.size > 10485760) {
        this.$message({
          message: "上传失败,请查看文件是否过大~（推荐上传大小：小于10M）",
          type: "warning",
        });
        return false;
      }
    },
    upload1(e) {
      this.CustomerReplay.PunchPic = e.Data.Message;
    },
    upload2(e) {
      this.CustomerReplay.RecordPic = e.Data.Message;
    },
    upload3(e) {
      this.CustomerReplay.ReviewReport = e.Data.Message;
    },
    delupload3() {
      this.CustomerReplay.ReviewReport = "";
    },
    uploaderror(e) {
      this.$message.error(e.Data.Message);
    },
  },
};
</script>
<style lang="less" scoped>
.upbox {
  margin: 0;
  border: 0;
  padding: 0;
}
.upload-demo {
  float: none;
  width: 110px;
  height: 110px;
}
::v-deep .upload-demo .el-upload {
  width: 110px;
  height: 110px;
  line-height: 110px;
}
::v-deep .upload-demo .el-upload-list {
  position: absolute;
}
::v-deep .upload-demo .is-success {
  width: 110px !important;
  height: 110px !important;
}
.cr {
  float: left;
  color: #d9001b;
  margin: 10px 0 0 0;
  line-height: 20px;
}
.clear {
  clear: both;
}
.pic {
  position: relative;
}
.pic img {
  display: block;
  width: 110px;
  height: 110px;
}
.pic .el-icon-error {
  position: absolute;
  top: -10px;
  left: 90px;
  font-size: 30px;
  color: #999;
  cursor: pointer;
}
.el-icon-folder-opened {
  font-size: 30px;
  color: #999;
}
</style>
